import React from "react";

import classnames from "classnames";
import isIntuit from "Intuit/isIntuit";
import { map } from "lodash";
import PropTypes from "prop-types";

import type { SelectProps } from "Theme/Select";

const SIFormSelect = ({ className, placeholder, noPlaceholder, options, name, input, meta, ...rest }: SelectProps) => {
  const classes = classnames(className, isIntuit() ? "SIFormSelect--intuit" : "SIFormSelect", {
    "SIFormSelect--error-intuit": isIntuit() && meta && meta.touched && meta.error !== undefined,
    "SIFormSelect--error": meta && meta.touched && meta.error !== undefined,
  });

  if (!Array.isArray(options)) {
    options = map(options, (value, label) => [value, label]);
  }

  return (
    <select className={classes} name={name} {...input} {...rest}>
      {!noPlaceholder && (
        <option className="SIFormSelect__option--placeholder" value="">
          {placeholder}
        </option>
      )}
      {options.map(
        (
          [optionValue, label], // dont render empty option dom elements
        ) => optionValue && <option value={optionValue} key={optionValue} children={label} />,
      )}
    </select>
  );
};

SIFormSelect.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};
SIFormSelect.defaultProps = {
  disabled: false,
  noPlaceholder: false,
  placeholder: "--------",
};
export default SIFormSelect;
